import React, { useRef, useEffect } from 'react';
import { useState } from 'react';
import useDimension from '../../../../hooks/useDimension';

interface SandboxIframeProps {
  visible: boolean;
  html: string;
  title?: string;
  sandbox?: string;
  style?: React.CSSProperties;
  onLoad?: () => void;
}

const SandboxIframe: React.FC<SandboxIframeProps> = ({
  visible,
  html,
  sandbox = 'allow-same-origin allow-scripts allow-popups allow-forms',
  style,
  onLoad,
}) => {
  const [url, setUrl] = useState('');
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { width } = useDimension(iframeRef);

  useEffect(() => {
    if (iframeRef.current?.contentDocument && html) {
      const srcDoc = `<!DOCTYPE html><html><head><link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"><style>body { font-family: 'Poppins'; margin: 0; } </style></head><body>${html}</body></html>`;

      const blobParts = [srcDoc];
      const blob = new Blob(blobParts, { type: 'text/html' });
      const objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    }
  }, [html, onLoad]);

  useEffect(() => {
    const iframeDoc = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;
    if (iframeRef.current) {
      iframeRef.current.style.height = iframeDoc?.documentElement.offsetHeight + 'px';
    }
  }, [width]);

  const divStyle: React.CSSProperties = {
    visibility: visible ? 'visible' : 'hidden',
    position: visible ? 'relative' : 'absolute',
    top: visible ? 0 : -10000,
    left: 0,
    right: 0,
    width: '100%',
  };

  if (!html) return null;

  return (
    <div style={divStyle}>
      <iframe
        ref={iframeRef}
        sandbox={sandbox}
        src={url}
        style={{ width: '100%', border: 'none', ...style }}
        onLoad={(e) => {
          onLoad?.();
          const currentTarget = e.currentTarget;

          const iframeDoc = currentTarget.contentDocument || currentTarget.contentWindow?.document;
          if (iframeDoc) {
            currentTarget.style.height = iframeDoc.documentElement.offsetHeight + 'px';
          }
        }}
      />
    </div>
  );
};

export default SandboxIframe;
